import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { AdminHeader } from "@/components/admin/AdminShared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CATS = ["Artikel", "Video", "Infografis", "Pemilih Pemula", "Pengawasan Partisipatif"];
const IMG = "https://images.unsplash.com/photo-1659718282409-203239812162?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
const EMPTY = { category: CATS[0], title: "", description: "", thumbnail: IMG, content: "<p>Konten materi edukasi.</p>" };

export default function EducationAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const load = () => api.get("/education").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const set = (k, v) => setForm({ ...form, [k]: v });

  const save = async () => {
    if (!form.title) { toast.error("Judul wajib diisi"); return; }
    await api.post("/education", form);
    toast.success("Materi ditambahkan"); setOpen(false); setForm(EMPTY); load();
  };
  const del = async (id) => { await api.delete(`/education/${id}`); toast.success("Materi dihapus"); load(); };

  return (
    <div>
      <AdminHeader title="Materi Edukasi" description="Kelola konten edukasi pemilu."
        action={<Button onClick={() => { setForm(EMPTY); setOpen(true); }} className="bg-brandred hover:bg-brandred-700 text-white" data-testid="add-edu-btn"><Plus className="h-4 w-4 mr-1.5" /> Tambah Materi</Button>} />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((e) => (
          <div key={e.id} className="bg-white border border-slate-200 rounded-xl overflow-hidden">
            <img src={e.thumbnail} alt={e.title} className="h-32 w-full object-cover" />
            <div className="p-4">
              <span className="text-[10px] font-bold text-brandred">{e.category}</span>
              <h4 className="font-bold text-navy text-sm line-clamp-2 mt-1">{e.title}</h4>
              <Button size="sm" variant="outline" onClick={() => del(e.id)} className="text-brandred border-red-200 mt-3"><Trash2 className="h-3.5 w-3.5 mr-1" /> Hapus</Button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Tambah Materi Edukasi</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div><Label>Kategori</Label>
              <Select value={form.category} onValueChange={(v) => set("category", v)}>
                <SelectTrigger className="mt-1.5" data-testid="edu-category"><SelectValue /></SelectTrigger>
                <SelectContent>{CATS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label>Judul</Label><Input value={form.title} onChange={(e) => set("title", e.target.value)} className="mt-1.5" data-testid="edu-title" /></div>
            <div><Label>Deskripsi</Label><Textarea value={form.description} onChange={(e) => set("description", e.target.value)} rows={2} className="mt-1.5" /></div>
            <div><Label>URL Thumbnail</Label><Input value={form.thumbnail} onChange={(e) => set("thumbnail", e.target.value)} className="mt-1.5" /></div>
            <div><Label>Konten (HTML)</Label><Textarea value={form.content} onChange={(e) => set("content", e.target.value)} rows={4} className="mt-1.5" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Batal</Button>
            <Button onClick={save} className="bg-brandred hover:bg-brandred-700 text-white" data-testid="save-edu">Simpan</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
